import { render } from "./UserMiniIcon.vue?vue&type=template&id=9d5c61d0&scoped=true"
import script from "./UserMiniIcon.vue?vue&type=script&lang=js"
export * from "./UserMiniIcon.vue?vue&type=script&lang=js"

import "./UserMiniIcon.vue?vue&type=style&index=0&id=9d5c61d0&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-9d5c61d0"

export default script